import { toast } from "react-toastify";
import NProgress from 'nprogress';
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
// --- Employee ECMS Adjustment Helpers ---

export const GetEmployeeEcmsAdjustmentHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/finance/ecms/getEmployeeEcmsAdjustment`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            month: params?.month,
            year: params?.year,
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Adjustments retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve employee adjustments", hasError: true, data: err?.response?.data }
    });
};

export const AddEmployeeEcmsAdjustmentHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ecms/addEmployeeEcmsAdjustment`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            ecms_adjustment_component_json: params?.ecms_adjustment_component_json,
            month: params?.month,
            year: params?.year,
            component_type: params?.component_type,
            record_date: params?.record_date,
            amount: params?.amount,
            comments: params?.comments || "",
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustment added successfully");
        return { message: "Adjustment added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add employee ECMS adjustment", hasError: true, data: err?.response?.data }
    });
};

export const UpdateEmployeeEcmsAdjustmentHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ecms/updateEmployeeEcmsAdjustment`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            ecms_adjustment_component_json: params?.ecms_adjustment_component_json,
            month: params?.month,
            year: params?.year,
            component_type: params?.component_type,
            record_date: params?.record_date,
            amount: params?.amount,
            comments: params?.comments || "",
            employee_ecms_adjustments_id: +params?.employee_ecms_adjustments_id,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustment updated successfully");
        return { message: "Adjustment updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update employee ECMS adjustment", hasError: true, data: err?.response?.data }
    });
};

export const DeleteEmployeeEcmsAdjustmentHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/finance/ecms/deleteEmployeeEcmsAdjustment`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_ecms_adjustments_id: +params?.employee_ecms_adjustments_id,
            month: params?.month,
            year: params?.year,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustment deleted successfully");
        return { message: "Adjustment deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete employee ECMS adjustment", hasError: true, data: err?.response?.data }
    });
};

// Exit Payroll Helpers

export const GenerateExitPayrollHelper = async (params) => {
  toast.dismiss();
  toast.info("Generating payroll...");
  return await axiosInstance(`/finance/ecms/generateExitPayroll`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: params?.employee_fk,
      month: params?.month,
      year: params?.year,
      user_id: getUserId(),
      custom_payable_days: params?.custom_payable_days,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Payroll generated successfully");
      return {
        message: "Payroll generated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message || "Failed to generate exit payroll");
      return {
        message: "Unable to generate payroll",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const GenerateExitDailyWagesPayrollHelper = async (params) => {
  toast.dismiss();
  toast.info("Generating payroll...");
  return await axiosInstance(`/finance/ecms/generateExitDailyWagesPayroll`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: params?.employee_fk,
      month: params?.month,
      year: params?.year,
      user_id: getUserId(),
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Payroll generated successfully");
      return {
        message: "Payroll generated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message || "Failed to generate exit daily wages payroll");
      return {
        message: "Unable to generate exit daily wages payroll",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const UpdateExitPayrollApproverStatusHelper = async (params) => {
  toast.dismiss();
  toast.info("Updating...");
  return await axiosInstance(`/finance/ecms/updateExitPayrollApproverStatus`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      status: params?.status,
      payroll_type: params?.payroll_type,
      employee_fk: params?.employee_fk,
      month: params?.month,
      year: params?.year
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Payroll status updated successfully");
      return {
        message: "Payroll status updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message || "Failed to update payroll status");
      return {
        message: "Unable to update payroll status",
        hasError: true,
        data: err?.response?.data,
      };
    });
};


export const GetExitPayrollEmployeeListHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/ecms/getExitPayrollEmployeeList`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      tab: params?.tab, // tab me 'regular' or 'daily wages'
      ats_work_location_json: params?.ats_work_location_json || null,
      user_id: getUserId()
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Payroll status updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to update payroll status",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const GetCustomPayableExitEmployeeHelper = async (params) => {
    return await axiosInstance(`/finance/ecms/getCustomPayableExitEmployeeExits`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk || null
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {    
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

export const GetExitPaySummaryHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/ecms/getExitPaySummary`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: params?.employee_fk,
      month: params?.month, 
      year: params?.year, 
      ats_work_location_json: params?.ats_work_location_json || null,
      user_id: getUserId()
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Payroll status updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to update payroll status",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const GetExitDailyWagesPaySummaryHelper = async (params) => {
  NProgress.start();
  return await axiosInstance(`/finance/ecms/getExitDailyWagesPaySummary`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      employee_fk: params?.employee_fk,
      month: params?.month, 
      year: params?.year, 
      ats_work_location_json: params?.ats_work_location_json || null,
      user_id: getUserId()
    },
  })
    .then((res) => {
      NProgress.done();
      return {
        message: "Payroll status updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      NProgress.done();
      return {
        message: "Unable to update payroll status",
        hasError: true,
        data: err?.response?.data,
      };
    });
};